<template>
  <div class="container-custom" v-if="csr">
    <!-- breadscrumbs -->
    <Breadscrumbs
      :links="[
        {
          name: 'ESG Page',
          to: {
            name: 'CSRPage'
          }
        },
        {
          name: 'Edit',
          to: {
            name: 'CSRPageEdit',
            query: {
              section: $route.query.section,
            },
          }
        }
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯 ESG Page</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>

    <!-- block 1 -->
    <div class="block mb-5">
      <!-- Page Title -->
      <label class="form-item d-flex pt-5">
        <h4 class="w-240px mr-5">Page Title</h4>
        <div class="flex-grow-1 my-n2">
          <v-text-field
            v-model="csr.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- Background -->
      <div class="form-item d-flex pa-5">
        <div class="w-240px mr-5">
          <h4>Background</h4>
          <div class="h5 ink-02-medium--text">
            建議尺寸：930px*550px <br />
            檔案大小限制：≤20MB <br />
            支援格式：.png/.jpg/.gif
          </div>
        </div>
        <div>
          <ImgUploader
            :imageUrl.sync="csr.background"
            dir="csr"></ImgUploader>
        </div>
      </div>
      <!-- Call to Action
      <label class="form-item d-flex pt-5">
        <h4 class="w-240px mr-5">Call to Action</h4>
        <div class="flex-grow-1 my-n2">
          <v-text-field
            v-model="csr.call_to_action"
            outlined
            dense
          ></v-text-field>
        </div>
      </label> -->
      <!-- CTA Type
      <div class="form-item d-flex pa-5">
        <h4 class="w-240px mr-5">CTA Type</h4>
        <div class="my-n2">
          <v-radio-group v-model="CTAType">
            <div
              v-for="type in ['Upload File', 'Link To']"
              :key="type"
              class="w-150px h-40px d-flex align-center mb-10px"
            >
              <v-radio class="mr-01" :value="type">
                <template v-slot:label>
                  <div class="h5 ink-01-emphasis--text w-120px">
                    {{ type }}
                  </div>
                </template>
              </v-radio>
            </div>
          </v-radio-group>
        </div>
        <div class="my-n1 flex-grow-1">
          <div class="mb-3"><button class="btn w-280px">上傳檔案</button></div>
          <div>
            <v-text-field
              v-model="csr.url"
              prepend-inner-icon="mdi-link"
              outlined
              dense
            ></v-text-field>
          </div>
        </div>
      </div> -->
      <!-- Description -->
      <div class="form-item d-flex pt-5">
        <div class="w-240px mr-5">
          <h4>Description</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-textarea
            v-model="csr.description"
            outlined
            dense
          ></v-textarea>
        </div>
      </div>
    </div>
    <!-- block 2 -->
    <div class="block mb-4" v-if="csr">
      <PageMenu :sections="sections">
        <component :is="sectionView" :csr="csr"></component>
      </PageMenu>
    </div>

    <!-- page-actions -->
    <div class="page-actions">
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ImgUploader from '@/components/ImgUploader.vue';
import PageMenu from '@/components/PageMenu.vue';

import ProjectFilter from '@/views/B-4__CSRPage/c/B-4-1-1__CSRPageEdit_ProjectFilter.vue';
import ProjectShowcasePage from '@/views/B-4__CSRPage/c/B-4-1-2__CSRPageEdit_ProjectShowcasePage.vue';
import VideoRotate from '@/views/B-4__CSRPage/c/B-4-1-3__CSRPageEdit_VideoRotate.vue';
import MainVisual from '@/views/B-4__CSRPage/c/C-4-4__CSRPageEdit_MainVisual.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';
import Breadscrumbs from '@/components/Breadscrumbs.vue';

export default {
  components: {
    ImgUploader,
    PageMenu,
    ProjectFilter,
    ProjectShowcasePage,
    VideoRotate,
    LangDialog,
    Breadscrumbs,
    MainVisual,
  },
  data: () => ({
    isLangOpen: false,
    pageTitle: '',
    background: '',
    callToAction: '',
    CTAType: 'Upload File',
    uploadFile: '',
    linkTo: '',
    sections: [
      { name: 'CSR Project Tab', component: 'ProjectFilter' },
      { name: 'Project Showcase', component: 'ProjectShowcasePage' },
      // { name: 'Video Rotate', component: 'VideoRotate' },
      { name: 'Main Visual', component: 'MainVisual' },
    ],
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('csr', ['csr']),
    sectionIndex() {
      const vm = this;
      return vm.$route.query.section || 0;
    },
    sectionView() {
      const vm = this;
      return vm.sections[vm.sectionIndex].component;
    },
  },
  async created() {
    if (this.csr === null) {
      await this.getCsr();
    }
  },
  methods: {
    ...mapActions('csr', {
      getCsr: 'find',
      save: 'save',
    }),
    toCsr() {
      this.$router.push({
        name: 'CSRPage',
        query: {
          section: this.$route.query.section,
        },
      });
    },
    cancelHandler() {
      this.toCsr();
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.save(this.csr).then(() => {
          this.toCsr();
        });
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
